module.exports = __webpack_public_path__ + "static/media/square.1eff95f0.png";